import { injectReducer } from '../../store/reducers';
import { injectSagas } from '../../store/sagas';


export default store => ({
  path : 'forgotten-password/sent',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const ForgottenPasswordSentContainer = require('./containers/ForgottenPasswordSent.js').default;
      const reducer = require('reducers/user').default;
      const sagas = require('sagas/sagas').default;

      injectReducer(store, { key: 'user', reducer });
      injectSagas(store, { key: 'sagas', sagas });

      cb(null, ForgottenPasswordSentContainer);
    }, 'forgottenPasswordSent');
  },
});



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/ForgottenPasswordSent/index.js